import { create } from "zustand";
import { persist } from "zustand/middleware";
import localStorageNames from "data/localStorageNames";

export const useMiniappConfirm = create(persist((set, get) => ({
    miniappConfirm: null,
    miniappConfirmId: null,
    updateMiniappConfirm: (newState) => {
        set({ miniappConfirm: newState });
    },
    getMiniappConfirm: () => {
        return get().miniappConfirm;
    },
    updateMiniappConfirmId: (newId) => {
        set({ miniappConfirmId: newId });
    },
    getMiniappConfirmId: () => {
        return get().miniappConfirmId;
    },
}), {
    name: localStorageNames.MINIAPP_CONFIRM
}));